import type { CameraAdapter } from './CameraAdapter';
import { BrowserCameraAdapter } from './BrowserCameraAdapter';

export class CameraAdapterFactory {
  /**
   * Créer un adapter caméra selon les capacités du navigateur
   */
  static create(): CameraAdapter | null {
    if (this.isGetUserMediaSupported()) {
      return new BrowserCameraAdapter();
    }
    return null;
  }

  /**
   * Vérifier si getUserMedia est supporté
   */
  static isGetUserMediaSupported(): boolean {
    return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  }

  /**
   * Lister les caméras disponibles
   */
  static async listDevices(): Promise<Array<{ deviceId: string; label: string }>> {
    return BrowserCameraAdapter.listDevices();
  }
}
